import React from "react";
import { arraysEqual } from 'helpers/utils'
import Gates from 'components/sports/csl/events/extreme/Gates';
import { Card } from "react-bootstrap";
import { isFinishedStatus } from "helpers/status";

export const TableExpanded = React.memo((props) => {
    const {row, config, resultStatus} = props;

    return (
        <>
            {row?.extCompetitor && !isFinishedStatus(resultStatus)
                && <Card className="extended-start-list my-1 p-1" >
                    {row?.extCompetitor}
                </Card>
            }
            <Gates config={config} row={row}  isCurrent={false}/>
        </>
    )
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    return arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults);
});

